import { render, staticRenderFns } from "./OnboardingIntegrationGoogleCalendar.vue?vue&type=template&id=23d80b34&scoped=true&"
import script from "./OnboardingIntegrationGoogleCalendar.vue?vue&type=script&lang=js&"
export * from "./OnboardingIntegrationGoogleCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d80b34",
  null
  
)

export default component.exports